export default __webpack_public_path__ + "static/unitedlogo-d3b156379f204a87cfa15a15923457b9.png";